import React, { useEffect, useState } from 'react';
import styles from './BrowserExtension.module.scss';
import { useTranslation } from 'react-i18next';
import { CheckIcon, DownloadIcon, ChromeIcon, EdgeIcon } from '../../../../components/Well/icons';
import cx from 'classnames';
import configs from '../../../../../../conf';

const extensionId = process.env.EXT_ID;

export const BrowserExtension = () => {
  const { t } = useTranslation();
  const [chromeExtensionInstalled, setChromeExtensionInstalled] = useState(false);
  const [edgeExtensionInstalled, setEdgeExtensionInstalled] = useState(false);
  const config = configs[process.env.APP_CONF];
  const chromeWebStoreUrl = config.chromeWebStoreUrl;
  const edgeWebStoreUrl = config.edgeWebStoreUrl;

  useEffect(() => {
    const checkProgress = async () => {
      const extensionExists = document.getElementById(extensionId);
      const checkStep1 = !!extensionExists;

      // Step 1 checker
      if (checkStep1) {
        setChromeExtensionInstalled(true);
      }
    };
    checkProgress();
  }, []);

  return (
    <div className={styles.softwareContainer}>
      <div className={`${styles.softwareTitle} ${styles.title}`}>{t('download_center.browser_extension')}</div>
      <div className={styles.softwareItem}>
        <div className={styles.itemTitleContainer}>
          <div className={styles.itemTitle}>
            <ChromeIcon />
            <div className={`${styles.profileTitle} ${styles.title}`}>{t('download_center.browser_extension.chrome')}</div>
          </div>
          <div className={styles.buttonContainer}>
            <a
              href={chromeWebStoreUrl}
              className={cx(
                { [styles.installed]: chromeExtensionInstalled, [styles.download]: !chromeExtensionInstalled },
                styles.aButton,
                'button'
              )}
              target="_blank"
            >
              {chromeExtensionInstalled ? (
                <>
                  <CheckIcon />
                  {t('general.installed')}
                </>
              ) : (
                <>
                  <DownloadIcon />
                  {t('general.download')}
                </>
              )}
            </a>
          </div>
        </div>
      </div>

      <div className={styles.softwareItem}>
        <div className={styles.itemTitleContainer}>
          <div className={styles.itemTitle}>
            <EdgeIcon />
            <div className={`${styles.profileTitle} ${styles.title}`}>{t('download_center.browser_extension.edge')}</div>
          </div>
          <div className={styles.buttonContainer}>
            <a
              href={edgeWebStoreUrl}
              className={cx(
                { [styles.installed]: edgeExtensionInstalled, [styles.download]: !edgeExtensionInstalled },
                styles.aButton,
                'button'
              )}
              target="_blank"
            >
              {edgeExtensionInstalled ? (
                <>
                  <CheckIcon />
                  {t('general.installed')}
                </>
              ) : (
                <>
                  <DownloadIcon />
                  {t('general.download')}
                </>
              )}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
